import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Fragment } from 'react';
import { kebabCase } from 'lodash';
import { Link } from '@hub/link';
import { Button } from '@hub/button';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const extraLinkProps = (newTab = false) => newTab ? {
  rel: 'noopener noreferrer',
  target: '_blank'
} : {};

export const LinkSection = ({
  heading,
  links,
  trackers
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [heading && /*#__PURE__*/_jsx(_Fragment, {
    children: 'url' in heading ? /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, extraLinkProps(heading.newTab)), {}, {
      href: heading.url,
      className: style.link,
      id: kebabCase(heading.text),
      sx: {
        display: 'block',
        fontWeight: 700,
        color: '#fff'
      },
      onClick: () => {
        var _trackers$clicked, _heading$trackingLabe;

        return trackers === null || trackers === void 0 ? void 0 : (_trackers$clicked = trackers.clicked) === null || _trackers$clicked === void 0 ? void 0 : _trackers$clicked.call(trackers, (_heading$trackingLabe = heading.trackingLabel) !== null && _heading$trackingLabe !== void 0 ? _heading$trackingLabe : heading.text);
      },
      children: heading.text
    })) : /*#__PURE__*/_jsx(Button, {
      variant: "plainText",
      as: props => /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, props), {}, {
        type: "button",
        "aria-labelledby": kebabCase(heading.text)
      })),
      sx: {
        color: '#fff',
        padding: 'spacing-none',
        textDecoration: 'none',
        fontWeight: 700,
        justifyContent: 'flex-start',
        height: 'auto'
      },
      onClick: () => {
        var _trackers$clicked2, _heading$trackingLabe2;

        trackers === null || trackers === void 0 ? void 0 : (_trackers$clicked2 = trackers.clicked) === null || _trackers$clicked2 === void 0 ? void 0 : _trackers$clicked2.call(trackers, (_heading$trackingLabe2 = heading.trackingLabel) !== null && _heading$trackingLabe2 !== void 0 ? _heading$trackingLabe2 : heading.text);
        heading.onClick();
      },
      children: heading.text
    })
  }), links && links.length > 0 && links.map((link, index) => /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, extraLinkProps(link.newTab)), {}, {
      href: link.url,
      className: style.link,
      sx: {
        display: 'block',
        marginTop: ['8px', '8px', '8px', 0]
      },
      onClick: () => {
        var _trackers$clicked3, _link$trackingLabel;

        return trackers === null || trackers === void 0 ? void 0 : (_trackers$clicked3 = trackers.clicked) === null || _trackers$clicked3 === void 0 ? void 0 : _trackers$clicked3.call(trackers, (_link$trackingLabel = link.trackingLabel) !== null && _link$trackingLabel !== void 0 ? _link$trackingLabel : link.text);
      },
      children: link.text
    })), link.links && link.links.length && link.links.map((subLink, subIndex) => /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, extraLinkProps(subLink.newTab)), {}, {
      href: subLink.url,
      className: style.link,
      sx: {
        display: 'block',
        marginTop: ['8px', '8px', '8px', 0]
      },
      onClick: () => {
        var _trackers$clicked4, _subLink$trackingLabe;

        return trackers === null || trackers === void 0 ? void 0 : (_trackers$clicked4 = trackers.clicked) === null || _trackers$clicked4 === void 0 ? void 0 : _trackers$clicked4.call(trackers, (_subLink$trackingLabe = subLink.trackingLabel) !== null && _subLink$trackingLabe !== void 0 ? _subLink$trackingLabe : subLink.text);
      },
      children: subLink.text
    }), subIndex))]
  }, index))]
});